<template>
	<!-- header -->
	<header id="header">
		<div class="hInner">
			<div class="logoWrap">
				<div class="logo"><router-link to="/"></router-link></div>
				<div class="hLine"></div>
				<div class="hName">{{ globaljs?.mb_nick }}</div>
			</div>
			<div class="hRight">
				<ul class="hTab">
					<li :class="{ active: route.path.split('/')[1] === '' }">
						<div class="menu"><router-link to="/"><span class="hIcon"></span>대시보드</router-link></div>
					</li>
					<li :class="{ active: ['/aiorder', '/aiorder_status'].some(page => route.path.startsWith(page)) }">
						<div class="menu"><router-link to="/aiorder"><span class="hIcon"></span>주문관리</router-link></div>
						<div v-if="globaljs.acc_type === 'lab'" class="dropdown-menu" aria-labelledby="navbarDropdown">
							<router-link class="dropdown-item" to="/aiorder">주문 관리</router-link>
							<router-link class="dropdown-item" to="/aiorder_status">입출고 현황</router-link>
						</div>
					</li>
					<template v-if="globaljs?.mb_boss_id === globaljs.mb_id || globaljs.mb_staff === 'Manager'">
<!--						<li :class="{ active: ['/charge', '/bill', '/pay'].some(page => route.path.startsWith(page)) }">-->
<!--							<div class="menu"><router-link :to="globaljs.acc_type === 'lab' ? '/charge' : '/bill'"><span class="hIcon"></span>정산관리</router-link></div>-->
<!--							<div class="dropdown-menu" aria-labelledby="navbarDropdown">-->
<!--								<router-link v-if="globaljs.acc_type === 'lab' && (globaljs?.mb_boss_id === globaljs.mb_id || globaljs.mb_staff === 'Manager')" class="dropdown-item" to="/charge">청구서 발행</router-link>-->
<!--								<router-link class="dropdown-item" to="/bill">청구서 관리</router-link>-->
<!--								<router-link class="dropdown-item" to="/pay">거래처 정산</router-link>-->
<!--							</div>-->
<!--						</li>-->
						<li
							:class="{ active: ['/manage_partner', '/manage_prosthesis', '/manage_staff'].some(page => route.path.startsWith(page)) }">
							<div class="menu"><router-link to="/manage_partner"><span class="hIcon"></span>환경설정</router-link></div>
							<div class="dropdown-menu" aria-labelledby="navbarDropdown">
								<router-link class="dropdown-item" to="/manage_partner">거래처 관리</router-link>
								<router-link v-if="globaljs.acc_type === 'lab' && (globaljs?.mb_boss_id === globaljs.mb_id || globaljs.mb_staff === 'Manager')" class="dropdown-item" to="/manage_prosthesis">보철물 관리</router-link>
								<router-link class="dropdown-item" to="/manage_staff">직원 관리</router-link>
							</div>
						</li>
					</template>
				</ul>
				<div class="aiBtn" @click="commonjs.pagePopup('/aiorder_step1', 'aiorder_step1')">AI 기공주문</div>
				<div class="hUser_area">
					<div class="hUser_rank hUser_rank1">{{ globaljs?.mb_boss_id === globaljs.mb_id ? '대표' : (globaljs?.mb_staff === 'Manager') ? '관리자' : '작업자' }}</div>
					<div class="hUser">{{ globaljs?.mb_name }}</div>
					<div class="hUser_sub">님</div>
					<div class="hArrow"></div>
					<div class="dropdown-menu" aria-labelledby="navbarDropdown">
						<router-link class="dropdown-item" to="/mypage">내 정보</router-link>
						<a class="dropdown-item" href="#" @click.prevent="logout_submit($event)">로그아웃</a>
					</div>
				</div>
			</div>
			<div class="mMenu">
				<div class="mMenuBtn">
					<div class="mline"></div>
					<div class="mline"></div>
					<div class="mline"></div>
				</div>
			</div>
		</div>

		<div class="mGnb">
			<div class="mclose">
				<div class="line"></div>
				<div class="line"></div>
			</div>
			<div class="mGnb_top">
				<div class="hUser_area">
					<div class="hUser_rank hUser_rank1">{{ globaljs?.mb_boss_id === globaljs.mb_id ? '대표' : (globaljs?.mb_staff === 'Manager') ? '관리자' : '작업자' }}</div>
					<div class="hUser">{{ globaljs?.mb_name }}</div>
					<div class="hUser_sub">님</div>
				</div>
				<div class="myMenu">
					<li><router-link to="/mypage">내 정보</router-link></li>
					<li class="line"></li>
					<li><a class="dropdown-item" href="#" @click.prevent="logout_submit($event)">로그아웃</a></li>
				</div>
			</div>
			<div class="aiBtn" @click="commonjs.pagePopup('/aiorder_step1', 'aiorder_step1')">AI 기공주문</div>
			<ul class="mTab">
				<li :class="{ active: route.path.split('/')[1] === '' }" class="main">
					<router-link class="m" to="/"><span class="hIcon"></span>대시보드</router-link>
				</li>
				<li :class="{ active: ['/aiorder', '/aiorder_status'].some(page => route.path.startsWith(page)) }" class="main">
					<router-link class="m" to="/aiorder"><span class="hIcon"></span>주문관리</router-link>
					<div class="sub" v-if="globaljs.acc_type === 'lab'">
						<router-link to="/aiorder">주문관리</router-link>
						<router-link to="/aiorder_status">입출고 현황</router-link>
					</div>
				</li>
				<template v-if="globaljs?.mb_boss_id === globaljs.mb_id || globaljs.mb_staff === 'Manager'">
<!--					<li :class="{ active: ['/charge', '/bill', '/pay'].some(page => route.path.startsWith(page)) }" class="main">-->
<!--						<router-link class="m" :to="globaljs.acc_type === 'lab' ? '/charge' : '/bill'"><span class="hIcon"></span>정산관리</router-link>-->
<!--						<div class="sub">-->
<!--							<router-link v-if="globaljs.acc_type === 'lab' && (globaljs?.mb_boss_id === globaljs.mb_id || globaljs.mb_staff === 'Manager')" to="/charge">청구서 발행</router-link>-->
<!--							<router-link to="/bill">청구서 관리</router-link>-->
<!--							<router-link to="/pay">거래처 정산</router-link>-->
<!--						</div>-->
<!--					</li>-->
					<li :class="{ active: ['/manage_partner', '/manage_prosthesis', '/manage_staff'].some(page => route.path.startsWith(page)) }" class="main">
						<router-link class="m" to="/manage_partner"><span class="hIcon"></span>환경설정</router-link>
						<div class="sub">
							<router-link to="/manage_partner">거래처 관리</router-link>
							<router-link v-if="globaljs.acc_type === 'lab' && (globaljs?.mb_boss_id === globaljs.mb_id || globaljs.mb_staff === 'Manager')" to="/manage_prosthesis">보철물 관리</router-link>
							<router-link to="/manage_staff">직원 관리</router-link>
						</div>
					</li>
				</template>
			</ul>
		</div>
	</header>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const router = useRouter();
const route = useRoute();

if (!globaljs.getIsLogin() || !globaljs.mb_nick) {
	router.push('/logout');
}

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const logout_submit = async (event) => {
	event.preventDefault();
	await withSubmitFlag(async () => {

		Swal.fire({
			title: '로그아웃 하시겠습니까?',
			text: '로그아웃',
			icon: 'question',

			showCancelButton: true, // cancel버튼 보이기. 기본은 원래 없음
			cancelButtonText: '취소', // cancel 버튼 텍스트 지정
			cancelButtonColor: '#d33', // cancel 버튼 색깔 지정
			confirmButtonText: '확인', // confirm 버튼 텍스트 지정
			confirmButtonColor: '#3085d6', // confrim 버튼 색깔 지정

			reverseButtons: false, // 버튼 순서 거꾸로
			allowOutsideClick: false,  // 외부 클릭 방지
			allowEscapeKey: false      // ESC 키 눌러서 닫기 방지

		}).then(async result => {
			// 만약 Promise리턴을 받으면,
			if (result.isConfirmed) { // 만약 모달창에서 confirm 버튼을 눌렀다면

				// 먼저 사용자 정보를 초기화하여 토큰 제거 (무한 루프 방지)
				globaljs.clearUserInfo();
				
				// Authorization 헤더 제거
				if (window.axios && window.axios.defaults) {
					delete window.axios.defaults.headers.common['Authorization'];
				}

				try {
					const response = await axios.post(`${SERVER_URL}/api/app/auth/logout`, {}, {
						validateStatus: function (status) {
							// 401 에러도 정상으로 처리하여 무한 루프 방지
							return status >= 200 && status < 500;
						}
					});

					if (response.status !== 401) {
						toast.fire({
							icon: "success",
							title: "로그아웃 완료!",
						});
					}

				} catch (error) {
					// 401 에러는 무시 (이미 로그아웃된 상태일 수 있음)
					if (error?.response?.status !== 401) {
						console.error(error?.response?.data);
						toast.fire({
							icon: "error",
							title: error?.response?.data?.result?.message || "로그아웃 중 오류가 발생했습니다."
						});
					}
				} finally {
					// 로그인 페이지로 이동
					setTimeout(() => {
						router.push("/login").catch(() => {
							window.location.href = "/login";
						});
					}, 100);
				}
			}
		});
	});
}

/*
router.beforeEach((to, from, next) => {
console.log('header beforeEach');
});
router.afterEach((to, from, next) => {
console.log('header afterEach');
});
*/

onMounted(() => {
	console.log('Header-onMounted', globaljs.mb_nick);
	if(globaljs.mb_nick === undefined || typeof globaljs.mb_nick === 'undefined') {
		router.push("/logout");
	}

//console.log('Header-onMounted', globaljs.acc_type);
	commonjs.DOMLoaded();

	// document.addEventListener('DOMContentLoaded', (event) => {
	// });

	// // 이미 DOMContentLoaded가 발생한 경우를 대비
	// if (document.readyState === 'complete' || document.readyState === 'interactive') {
	// }
});
</script>
